module.exports = __webpack_public_path__ + "assets/photos/memories/frame-10--7dd75c19dc505caf801e41053161ed1e.png";